import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { env } from "./env";

let client: SupabaseClient | null = null;

/** Supabase Auth istemcisi (yalnızca giriş/2FA; veriler API'den gelir) */
export function supabase(): SupabaseClient {
  if (!client) {
    client = createClient(env.supabaseUrl ?? "http://invalid", env.supabaseAnonKey ?? "missing", {
      auth: { persistSession: true, autoRefreshToken: true, storageKey: "poji-admin-auth" },
    });
  }
  return client;
}
